import { useSyncExternalStore } from 'react';
import { getMetrics, subscribeToMetrics, type ScreenMetrics } from './screenUtil';

/**
 * Реактивный доступ к метрикам экрана — аналог `MediaQuery.of(context)`
 * и `context.isLandscape` из `build_context_extension.dart`.
 */
export function useScreen(): ScreenMetrics {
  return useSyncExternalStore(subscribeToMetrics, getMetrics, getMetrics);
}

/** `context.isLandscape` */
export function useIsLandscape(): boolean {
  return useScreen().isLandscape;
}
